// tslint:disable: max-line-length
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import Icon from 'lqa-ui/lib/Components/Icon';
import './styles.scss';
import { getItem } from '../../utils/localStorage';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  assessments as assessmentApi,
  overallCustomScore,
} from '../Dashboard/apiCaller';
import { missedstandardApi } from './apiCaller';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent/index';
import SimulateButton from './SimulateButtons';
import { useProducedState } from '../../hooks/useProducedState';
import {
  getImproveOpportunities,
  overallScore,
} from '../../components/Dashboard/apiCaller';
import { round, range } from 'lodash';
import '../../style/main.scss';
import HotelAssessmentSelection from '../../components/commons/Header/HotelAssessmentSelection';
import {
  getComparedToAverageClassStyle,
  getComparedToClassStyle,
} from '../../helpers/charts';
import Skeleton from 'react-loading-skeleton';
import { getStandards } from './../../requests/actionPlan';
import { showErrorMessage } from '../../helpers/showMessage';
import { StandardPerformaceSelector } from '../commons/StandardPerformanceSelector/standardPerformanceSelector';
import { orderBy } from 'lodash';
import Tags from 'lqa-ui/lib/Components/Tags';
import { DEFAULT_VIEW } from '../../utils/constants';
import Donut from 'lqa-ui/lib/Components/Donut';
import { isUnauthorized } from '../../utils/common';
import PendingAssessment from '../commons/PendingAssessment';
import { gethasAssessment } from '../../helpers/handleBrandAndHotelData';
import { AppHeader } from '../../app/common/sharedComponents/AppHeader';
import { BottomSheet } from './../../app/common/sharedComponents/BottomSheet';
import { ButtonLarge } from './../../app/common/sharedComponents/buttons/ButtonLarge';
import { HeaderContainer } from './../../app/common/sharedStyledComponents/MyAuditGenericStyles.styled';
import { ButtonSmall } from './../../app/common/sharedComponents/buttons/ButtonSmall';
import Refresh from './../../app/common/icons/Refresh';
import {
  RowSeparater,
  OptionsButtonContainer,
  OptionsButtonCustomContainer,
} from './SimulateStandard.styled';

const MissedStandardContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  height: 100vh;
  align-items: center;
  width: 100%;
`;
const ContentArea = styled('div')`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-top: 190px;
`;

const BottomSheetContainer = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.spacing.md};
  margin-bottom: 20px;
`;

const MissedStandard = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const loc: any = { ...location };

  const l = loc.state;
  const { selectedCompset } = l;
  const brandId = getItem('selectedBrand');
  const defaultValues = DEFAULT_VIEW.find((o: any) => o.brandId === brandId);

  const userData = getItem('user');
  const [selectedHotel, setSelectedHotel] = useState(getItem('selectedHotel'));
  const [selectedClient, setSelectedClient] = useState(
    getItem('selectedClient')
  );
  const [assessments, setAssessments] = useState<
    {
      stayStart: string;
      id: number;
    }[]
  >([]);
  const [overall, setOverall] = useState<
    | {
      score: number;
      change: number;
      rankingPosition: number;
      rankingTotal: number;
      compSetAverageScore: number;
    }
    | undefined
  >(undefined);
  const [isLoading, setIsLoading] = React.useState(true);
  const [selectedAssessment, setSelectedAssessment] = useState<string | undefined>(undefined);
  const [missedStandards, setMissedStandards] = useState<any>(undefined);
  const [result, setResult] = useState<any>([]);
  const [selectedBtn, setSelectedBtn] = useState<any>(undefined);
  const [selected, produceSelected] = useProducedState<Record<number, boolean>>(
    {}
  );
  const [successfulValue, produceSelectedValue] = useProducedState<
    Record<number, number>
  >({});
  const [currentPage, setCurrentPage] = useState(1);
  const [standardId, setStandardId] = useState<any>(undefined);
  const [standard, setStandard] = useState(
    defaultValues && defaultValues.defaultCustomScoreNumber
      ? defaultValues.defaultCustomScoreNumber
      : 'LQA'
  );
  const [performanceClassification, setPerformanceClassification] =
    useState<any>('all');
  const [sort, setSort] = useState<any>({ key: 'id', dir: 'desc' });
  const [hasAssessment, setHasAssessment] = useState(gethasAssessment());
  const [isOpenBottomSheet, setOpenBottomSheet] = useState(false);

  const clickhandler = (alreadyAssignedUsers, standardId) => {
    getStandards()
      .then((res) => {
        let isFound = false;
        let stdNew;
        for (const dept of res) {
          if (
            dept.missedStandards &&
            dept.missedStandards.length > 0 &&
            dept.missedStandards.find((k) => k.standardId === standardId)
          ) {
            isFound = true;
            stdNew = {
              category: dept,
              std: dept.missedStandards.find(
                (k) => k.standardId === standardId
              ),
            };
            navigate('/createActionPlan', {
              state: {
                alreadyAssignedUsers,
                sourceTemplateCategoryId: stdNew.category.categoryId,
                visit: stdNew.category.visit,
                selectedStandards: [{ standardId }],
              },
            });
          }
          if (isFound) {
            return;
          }
        }
      })
      .catch((error) => {
        showErrorMessage('Unable to retrieve standards');
      });
  };

  useEffect(() => {
    if (selectedAssessment && performanceClassification && hasAssessment) {
      setIsLoading(true);
      Promise.all([
        missedstandardApi(
          selectedAssessment,
          currentPage,
          standard,
          performanceClassification
        ),
        getImproveOpportunities(selectedAssessment),
        overallScore(selectedAssessment, selectedCompset),
        overallCustomScore(selectedAssessment),
      ])
        .then((res) => {
          setMissedStandards(res[0].results);
          setResult(res[1]);
          if (standard === 'LQA') {
            setOverall(res[2]);
          } else if (res[3]) {
            const overallCustomScore = res[3].find(
              (item) => item.customScoreNumber === standard
            );
            if (overallCustomScore) {
              setOverall(overallCustomScore);
            }
          }
          setIsLoading(false);
        })
        .catch((err) => {
          showErrorMessage(
            'Unable to retrieve MissedStandards',
            !isUnauthorized(err)
          );
        });
    }
  }, [selectedAssessment, performanceClassification, standard]);

  useEffect(() => {
    setMissedStandards(orderBy(missedStandards, sort.key, [sort.dir]));
  }, [sort]);

  useEffect(() => {
    if (selectedHotel && hasAssessment) {
      assessmentApi()
        .then((response) => {
          setAssessments(response);
          produceSelected((draft) => {
            Object.keys(draft).map((key, index) => {
              draft[key] = false;
            });
          });
          produceSelectedValue((d) => {
            Object.keys(d).map((key, index) => {
              d[key] = undefined;
            });
          });
          const assess = response.find(
            (o) => o.stayStart === getItem('selectedAssessmentDate')
          )
            ? getItem('selectedAssessmentDate')
            : undefined;
          setSelectedAssessment(assess ? assess : response[0].stayStart);
        })
        .catch((err) => console.error(err));
    }
  }, [selectedHotel, selectedClient]);

  const originalScore = overall ? overall.score : 0;
  const Stats = result.stats ? result.stats : [];
  const calculatedPercentages = Stats.map((o) => {
    return (o.met / o.total) * 100;
  });

  const percentage =
    Math.round(
      (calculatedPercentages.reduce((acc, o) => acc + o, 0) /
        calculatedPercentages.length) *
      10
    ) / 10;
  const statsClone = JSON.parse(JSON.stringify(Stats));
  if (result && result.standards) {
    result.standards.forEach((isMaximised, i) => {
      if (selected[i]) {
        const missedStandard = result.standards[i];
        const missedServices = missedStandard.missedServiceCodes
          ? missedStandard.missedServiceCodes
          : [];
        missedServices.forEach((benchmarkDepartmentId) => {
          const statRow = statsClone.find(
            (o) => o.benchmarkDepartmentId === benchmarkDepartmentId
          );
          if (statRow) {
            statRow.met++;
          }
        });
      }
    });
  }

  const simulatedPercentage = statsClone.map((o) => {
    return (o.met / o.total) * 100;
  });

  const simpercentage =
    Math.round(
      (simulatedPercentage.reduce((acc, o) => acc + o, 0) /
        simulatedPercentage.length) *
      10
    ) / 10;
  const changePercentage = simpercentage - percentage;

  const overallScoreD = originalScore;
  let displayScore = round(
    parseFloat(overallScoreD + changePercentage + ''),
    2
  );
  if (displayScore > 100) {
    displayScore = 100; // limiting to 100% because of bonus question.
  }
  const standards = result.standards
    ? result.standards.map((row, index) => {
      return {
        name: row.standard,
        emulating: selected[index],
        opportunities: row.total,
        successful: successfulValue[index]
          ? successfulValue[index]
          : row.total - row.missedCount,
        missedCount: row.missedCount,
        onClick () {
          produceSelected((draft) => {
            draft[index] = !draft[index];
          });
          produceSelectedValue((d) => {
            if (!selected[index]) {
              d[index] = this.opportunities;
            } else {
              d[index] = this.opportunities - this.missedCount;
            }
          });
        },
      };
    })
    : [];

  const changeClassification = (change) => {
    let text;
    switch (change) {
      case 'service':
        text = 'Service';
        break;
      case 'efficiency':
        text = 'Efficiency';
        break;
      case 'employeeBehavioural':
        text = 'EI Behavioral';
        break;
      case 'cleanliness':
        text = 'Cleanliness';
        break;
      case 'product':
        text = 'Product';
        break;
      case 'salesOpportunity':
        text = 'Sales Opportunity';
        break;
      case 'food':
        text = 'Food Quality';
        break;
      case 'sustainability':
        text = 'Sustainability';
        break;
      default:
        text = '';
        break;
    }
    return text;
  };
  const [isScrolledDown, setIsScrolledDown] = useState(false);

  let lastScroll = 0;
  const isScrolled = false;
  useEffect(() => {
    const handleScroll = () => {
      const currentScroll =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      const scrollDirection = currentScroll < lastScroll;
      const shouldToggle = isScrolled && scrollDirection;
      setIsScrolledDown(window.pageYOffset > 0 && !shouldToggle);
      lastScroll = currentScroll;
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isScrolled]);

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }, []);

  if (!hasAssessment) {
    return (
      <>
        <PendingAssessment
          assessments={assessments}
          setAssessments={setAssessments}
          selectedHotel={selectedHotel}
          setSelectedHotel={setSelectedHotel}
          selectedClient={selectedClient}
          setSelectedClient={setSelectedClient}
          selectedAssessment={selectedAssessment}
          setSelectedAssessment={setSelectedAssessment}
          isSelectDate={true}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          selectedCompset={selectedCompset}
          setSelectedCompset={() => { }}
          hasAssessment={hasAssessment}
          setHasAssessment={setHasAssessment}
        />
      </>
    );
  }
  return (
    <MissedStandardContainer>
      <HeaderContainer>
        <AppHeader />
        <HotelAssessmentSelection
          assessments={assessments}
          setAssessments={setAssessments}
          selectedHotel={selectedHotel}
          setSelectedHotel={setSelectedHotel}
          selectedClient={selectedClient}
          setSelectedClient={setSelectedClient}
          selectedAssessment={selectedAssessment}
          setSelectedAssessment={setSelectedAssessment}
          isSelectDate={true}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          selectedCompset={selectedCompset}
          setSelectedCompset={() => { }}
          hasAssessment={hasAssessment}
          setHasAssessment={setHasAssessment}
        />
      </HeaderContainer>
      {isLoading || !selectedAssessment || !overall || !missedStandards ? (
        <ContentArea>
          <div className="box-shadow d-block">
            <div className="m-10 mt-20 mb-20">
              <Skeleton
                containerClassName="flex-1"
                height={50}
                borderRadius={25}
              />
              <div className="center-align-skeleton mb-20">
                <Skeleton width={120} height={120} circle={true} />
              </div>
              <div className="row-separater-skeleton mb-10">
                <Skeleton width={45} height={25} borderRadius={40} />
                <Skeleton width={45} height={25} borderRadius={40} />
                <Skeleton width={45} height={25} borderRadius={40} />
                <Skeleton width={45} height={25} borderRadius={40} />
                <Skeleton width={45} height={25} borderRadius={40} />
              </div>
              <Skeleton
                containerClassName="flex-1"
                height={50}
                borderRadius={5}
              />
              <Skeleton
                containerClassName="flex-1"
                height={80}
                borderRadius={5}
                count={5}
              />
            </div>
          </div>
        </ContentArea>
      ) : (
        <ContentArea>
          <div className={`fixed-block ${isScrolledDown ? 'active' : ''}`}>
            <div className="ml-10 mr-10">
              <StandardPerformaceSelector
                standard={standard}
                setStandard={setStandard}
                selectedHotel={selectedHotel}
                selectedClient={selectedClient}
                selectedAssessment={selectedAssessment}
                performanceClassification={performanceClassification}
                setPerformaceClassification={setPerformanceClassification}
                isSelf={false}
              />
            </div>

            <div className="theme-default d-block m-7 mb-20">
              <RowSeparater>
                <div className="donut-container-missed w-35 pb-10">
                  <Donut
                    percentage={displayScore}
                    size={160}
                    intent={getComparedToAverageClassStyle(
                      displayScore - overall.compSetAverageScore
                    )}
                    decimals={1}
                    percentageSign={true}
                    change={changePercentage}
                    changeIntent={getComparedToClassStyle(changePercentage)}
                  />
                </div>
                <OptionsButtonContainer>
                  <div className="piechartTitle">LQA Missed Standards</div>
                  <div className="piechartSubTitle" />
                  <div className=" pl-10 pr-10 mt-10">
                    <SimulateButton
                      produceSelected={produceSelected}
                      produceSelectedValue={produceSelectedValue}
                      selected={selected}
                      standards={standards}
                      isMissedStandard={true}
                      setSelectedBtn={setSelectedBtn}
                      selectedBtn={selectedBtn}
                    />
                    <OptionsButtonCustomContainer>
                      <ButtonSmall
                        inverted={true}
                        outlined={true}
                        rounded={true}
                        title="Custom"
                        backgroundColor={
                          selectedBtn === 4 ? 'verdigrisDark' : 'battleShipGray'
                        }
                        onClick={() => {
                          setSelectedBtn(4);
                          produceSelected((draft) => {
                            range(200).map((o) => (draft[o] = false));
                          });
                          produceSelectedValue((d) => {
                            range(200).map(
                              (o) =>
                              (d[o] =
                                standards[o].total - standards[o].missedCount)
                            );
                            // }
                          });
                        }}
                      />
                      <ButtonSmall
                        title="Reset"
                        inverted={true}
                        outlined={true}
                        rounded={true}
                        leftIcon={
                          <Refresh strokeColor="oxfordBlue" size={12} />
                        }
                        onClick={() => {
                          setSelectedBtn(5);
                          produceSelected((draft) => {
                            range(200).map((o) => (draft[o] = false));
                          });
                          produceSelectedValue((d) => {
                            range(200).map(
                              (o) =>
                              (d[o] =
                                standards[o].total - standards[o].missedCount)
                            );
                            // }
                          });
                        }}
                      />
                    </OptionsButtonCustomContainer>
                  </div>
                </OptionsButtonContainer>
              </RowSeparater>
            </div>

            <table style={{ borderCollapse: 'collapse', width: '100%' }}>
              <tr>
                <th>
                  Standard{' '}
                  <Icon
                    kind="arrow-down"
                    height={10}
                    width={10}
                    onClick={() =>
                      setSort({
                        key: ['label'],
                        dir: sort.dir === 'asc' ? 'desc' : 'asc',
                      })
                    }
                  />
                </th>
                <th>
                  Number{' '}
                  <Icon
                    kind="arrow-down"
                    height={10}
                    width={10}
                    onClick={() =>
                      setSort({
                        key: ['missedOpportunities'],
                        dir: sort.dir === 'asc' ? 'desc' : 'asc',
                      })
                    }
                  />
                </th>
                <th>
                  %{' '}
                  <Icon
                    kind="arrow-down"
                    height={10}
                    width={10}
                    onClick={() =>
                      setSort({
                        key: ['missPercentage'],
                        dir: sort.dir === 'asc' ? 'desc' : 'asc',
                      })
                    }
                  />
                </th>
              </tr>
            </table>
          </div>

          <div className="missedStandardTable">
            <table style={{ borderCollapse: 'collapse' }}>
              {missedStandards ? (
                missedStandards.map((missedStandard, indx) => {
                  return (
                    // tslint:disable-next-line:jsx-key
                    <tr
                      className={`${selected[indx] ? 'background-EEF9F8' : ''}`}
                      onClick={() => {
                        if (selectedBtn === 4) {
                          produceSelected((draft) => {
                            [indx].map((o) => (draft[o] = !draft[o]));
                          });
                          produceSelectedValue((d) => {
                            if (!selected[indx]) {
                              [indx].map((o) => (d[o] = standards[o].total));
                            } else {
                              [indx].map(
                                (o) =>
                                (d[o] =
                                  standards[o].total -
                                  standards[o].missedCount)
                              );
                            }
                          });
                        }
                      }}
                    >
                      <td>
                        {performanceClassification !== 'all' ? (
                          <div className="tagsContainer fw-600 f-10 lh-12 color-717171 w-100">
                            <Tags
                              data={[
                                {
                                  label: changeClassification(
                                    performanceClassification
                                  ),
                                },
                              ]}
                            />
                            <br />
                          </div>
                        ) : (
                          <span />
                        )}
                        {missedStandard.label}{' '}
                      </td>
                      <td>
                        {missedStandard.missedOpportunities} /{' '}
                        {missedStandard.opportunities}
                      </td>
                      <td className="icon-percentage-container">
                        <span>{missedStandard.missPercentage}%</span>
                        <Icon
                          kind="edit-diary"
                          height={15}
                          width={15}
                          style={{ fill: 'black' }}
                          onClick={() => {
                            setOpenBottomSheet(true);
                            setStandardId(missedStandard.standardId);
                          }}
                        />
                      </td>
                    </tr>
                  );
                })
              ) : (
                <LoadingContent />
              )}
            </table>
          </div>
        </ContentArea>
      )}
      <BottomSheet
        isOpen={isOpenBottomSheet}
        onClose={() => setOpenBottomSheet(false)}
      >
        <BottomSheetContainer>
          <ButtonLarge
            title="Create Action Plan"
            onClick={() => {
              clickhandler(
                userData && userData.user && userData.user.id
                  ? [userData.user.id]
                  : [],
                standardId
              );
            }}
          />
        </BottomSheetContainer>
      </BottomSheet>
    </MissedStandardContainer>
  );
};

export default MissedStandard;
